import React, { useEffect, useState } from "react";
import { getBusinessDetails } from "../services/settings";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContextProvider";

const BusinessName = () => {
  const [businessName, setBusinessName] = useState("");
  const { globalProfile } = useAuth();

  const handleBusinessDetails = async () => {
    try {
      const res = await getBusinessDetails();
      setBusinessName(res.data.businessName);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    handleBusinessDetails();
  }, [globalProfile]);

  return <span>{businessName}</span>;
};

export default BusinessName;
